// extracted by mini-css-extract-plugin
module.exports = {"plusSign":"styles_plusSign__FUdZv"};